import { useMutation } from "react-query";
import { postGeoDetails } from "./api";

export const useGetGeoDetails = () => {
  return useMutation((params) => postGeoDetails(params));
};
